import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body{
    height: 100vh;
    font: 400 16px Roboto, sans-serif;
  }

  #root{
    height: 100%;
    --default-page-content-height:calc(100vh - var(--nav-bar-height));
  }

  .swal2-container{
    z-index: 1401;
  }


`;
